module.exports = __webpack_public_path__ + "img/location.86470268.png";